import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import 'mapbox-gl/dist/mapbox-gl.css';

/**
 * Guards against a stale bundle.
 *
 * The console is served through a development server whose assets carry an
 * ETag but no cache directive, so a browser can keep running an old build.
 * Newly added controls then appear unresponsive even though the server is
 * already serving the new code.
 *
 * A lightweight, uncached probe compares the current build fingerprint with
 * the one this tab booted from and reloads the page once when they differ.
 */
const STAMP_KEY = 'bluenode.bundle.stamp';
const RELOAD_KEY = 'bluenode.bundle.reloaded';

const fingerprint = async () => {
  // Development server: the ETag changes with every rebuild.
  try {
    const response = await fetch('/static/js/bundle.js', {
      method: 'HEAD',
      cache: 'no-store',
    });
    const etag = response.headers.get('etag');
    if (etag) return `etag:${etag}`;
  } catch (error) {
    /* the probe is best effort */
  }

  // Production build: the hashed entry in the asset manifest identifies it.
  try {
    const response = await fetch('/asset-manifest.json', { cache: 'no-store' });
    if (!response.ok) return null;
    const manifest = await response.json();
    const entry = manifest?.files?.['main.js'];
    return entry ? `manifest:${entry}` : null;
  } catch (error) {
    return null;
  }
};

const checkBundleVersion = async () => {
  const current = await fingerprint();
  if (!current) return;

  const stored = localStorage.getItem(STAMP_KEY);
  if (stored && stored !== current) {
    // reload at most once per build so a failing reload cannot loop
    if (sessionStorage.getItem(RELOAD_KEY) !== current) {
      sessionStorage.setItem(RELOAD_KEY, current);
      localStorage.setItem(STAMP_KEY, current);
      window.location.reload();
      return;
    }
  }
  localStorage.setItem(STAMP_KEY, current);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

checkBundleVersion();
setInterval(checkBundleVersion, 30000);
window.addEventListener('focus', checkBundleVersion);
